﻿import { OpenGLParser } from "./parser";

/**
 * Class to obtains all the data of the user's OpenGL.
 * It uses a parser to extract the data.
 * */
export const openGL = {

    /**
     * @returns The parser to extract the OpenGl data. It will depends on with version is using the user.
     * By now, only admits version 1, but if user has version 2, the parser is configured to use 1.
     * */
    getParser(): OpenGLParser | null {
        const webglVersion: number = window.location.search.indexOf(`v=2`) > 0 ? 2 : 1;

        if ((webglVersion === 2 && !window.WebGL2RenderingContext) ||
            (webglVersion === 1 && !window.WebGLRenderingContext)) {
            return null;
        }
        else {
            return new OpenGLParser(webglVersion);
        }
    }
};
